/* Galeria karty produktu 3.0 (runda 2, 18.10.2026, sesja 7ea9476e; decyzje CEO i pomiary: docs/research/pdp-galeria-2026-10-17/runda2/).
   Warstwa NA galerii motywu (media-gallery.js + SliderComponent z global.js), bez podmiany ich kodu. Tor przewijany natywnie
   z przyciąganiem (dotyk bez JS), własny kod tylko dla myszy, strzałek, klawiszy, wskaźnika pod zdjęciem i licznika dla czytników.
   - telefon i tablet (< 990 px): test A/B (CEO 18.10), wariant na <media-gallery> w data-sv-ab i data-sv-ind:
       dots   -> data-sv-ind="dots-flow": kropki pod zdjęciem, pigułka płynie za palcem (animacja sterowana przewijaniem,
                 zapas JS), dotknięcie albo przesunięcie palca po rzędzie kropek = skok do zdjęcia;
       thumbs -> data-sv-ind="thumbs": miniatury 56 px pod zdjęciem, przewijane poziomo.
     Losowanie raz na przeglądarkę: localStorage svGalAB, 50/50 z crypto.getRandomValues; storage zablokowany = dots bez zapisu.
     QA: ?sv_ab=dots|thumbs (bez zapisu). Zdarzenie DOM sv:gallery-ab { variant, gallery } raz na odsłonę (assets/sv-events.js -> GA4).
   - komputer (>= 990 px, poza testem): miniatury z lewej, strzałki na zdjęciu zawsze widoczne, przeciąganie myszą, klawisze, gładzik.
   - bez pełnego ekranu i powiększenia (CEO 18.10): dotknięcie i klik zdjęcia nic nie robią, natywne szczypanie strony zostaje.
   - licznik motywu tylko dla czytników ekranu.
   Poprawki z rundy 2 (dowody: runda2/technika/RAPORT.md, P4):
   1. chwyt myszą zatrzymuje trwający dojazd (jeden właściciel zapisów scrollLeft; LIVE 2.0: dojazd i przeciąganie w tej samej klatce);
   2. cel po puszczeniu: rzut = sąsiednie zdjęcie w kierunku ruchu od miejsca puszczenia, bez rzutu = najbliższe zdjęcie;
   3. prędkość z ostatnich 80 ms ruchu; kursor stoi dłużej niż 60 ms = prędkość 0;
   4. chwyt na strzałce też przeciąga, klik bez ruchu dalej działa jak strzałka;
   5. strzałki i klawisze liczą od celu w drodze, więc szybkie kliknięcia się sumują;
   6. numer zdjęcia od najbliższego zdjęcia (Math.round), zmiana tylko przy zmianie numeru, bez odczytów układu przy przewijaniu;
   7. gumka na końcach toru przy przeciąganiu myszą (translate slajdów, scrollLeft bez zmian);
   8. licznik bez kosztu przy przewijaniu: SliderComponent.update() przy każdym scrollu podmienia tekst licznika i czyta układ
      (6-11 ms na klatkę przy CPU 4x) - jego spany odpinamy, cyfrę w naszych kopiach zmieniamy przez nodeValue. */
(function () {
  if (window.svGaleria) return;
  var SEL = 'media-gallery[data-sv-galeria]';
  var desk = window.matchMedia('(min-width: 990px)');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var VFLICK = 0.3; /* px/ms: szybciej = rzut (następne zdjęcie w kierunku ruchu) */
  var AB_KEY = 'svGalAB';

  function trackOf(g) { return g.querySelector('.product__media-list'); }
  function slidesOf(g) {
    var t = trackOf(g); if (!t) return [];
    return Array.prototype.filter.call(t.children, function (li) { return li.classList.contains('product__media-item') && !li.classList.contains('hidden'); });
  }
  function viewerComp(g) { return g.querySelector('slider-component[id^="GalleryViewer"]'); }
  function isImage(li) { return !!li && !!li.querySelector('img') && !li.querySelector('video, iframe, model-viewer, product-model, .deferred-media'); }
  function emit(name, detail) { try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {} }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function easeOut(t) { return 1 - Math.pow(1 - t, 3); }
  function easeInOut(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  /* wariant testu A/B (telefon i tablet): adres QA > zapis w przeglądarce > losowanie 50/50 z zapisem; błąd storage = dots */
  function abVariant() {
    try { var q = new URLSearchParams(location.search).get('sv_ab'); if (q === 'dots' || q === 'thumbs') return q; } catch (e) {}
    try {
      var v = localStorage.getItem(AB_KEY);
      if (v === 'dots' || v === 'thumbs') return v;
      var r;
      try { var a = new Uint8Array(1); crypto.getRandomValues(a); r = a[0] < 128; } catch (e) { r = Math.random() < 0.5; }
      v = r ? 'dots' : 'thumbs';
      localStorage.setItem(AB_KEY, v);
      return v;
    } catch (e) { return 'dots'; }
  }
  var abSent = false;

  /* geometria toru: liczona przy starcie, zmianie rozmiaru i zmianie koloru (nigdy w obsłudze dotknięcia/przewijania) */
  function measure(g) {
    var tr = trackOf(g), list = slidesOf(g), S = g._sv || (g._sv = {});
    S.tr = tr; S.n = list.length; S.w = tr.clientWidth || 1;
    if (list.length > 1) { var a = list[0].getBoundingClientRect(), b = list[1].getBoundingClientRect(); S.step = (b.left - a.left) || S.w; }
    else S.step = S.w;
    S.max = Math.max(0, tr.scrollWidth - tr.clientWidth);
    var th = g.querySelector('[id^="GalleryThumbnails"] .thumbnail-list');
    S.ids = list.map(function (li) { return li.dataset.mediaId; });
    /* miniatura zdjęcia koloru: motyw pokazuje ją tylko jako pierwszą (section-main-product.css, .thumbnail-list_item--variant:not(:first-child)),
       a Pony z „2. zdjęciem przed kolorem” ma zdjęcie koloru na 3. miejscu toru - bez tego brakowało jego miniatury (komputer i wariant miniatur) */
    if (th) Array.prototype.forEach.call(th.querySelectorAll('.thumbnail-list_item--variant'), function (li) { li.classList.toggle('is-sv-show', S.ids.indexOf(li.dataset.target) >= 0); });
    S.thPos = new Map();
    if (th && (desk.matches || g.getAttribute('data-sv-ind') === 'thumbs')) {
      S.thCH = th.clientHeight; S.thST = th.scrollTop; S.thCW = th.clientWidth; S.thSL = th.scrollLeft;
      Array.prototype.forEach.call(th.querySelectorAll('[data-target]'), function (li) { S.thPos.set(li.dataset.target, [li.offsetTop, li.offsetHeight, li.offsetLeft, li.offsetWidth]); });
    }
    var dts = g.querySelector('.svg-dots');
    if (dts && g._svDots) { if (dts.querySelectorAll('.svg-dot').length !== S.n) g._svDots(); else g._svSpan(); }
    return S;
  }
  function posOf(S, i) { return clamp(i * S.step, 0, S.max); }
  function idxAt(S, x) { return clamp(Math.round(x / S.step), 0, Math.max(0, S.n - 1)); }

  /* dojazd toru w rAF (przyciąganie wyłączone w trakcie); jeden właściciel: nowy dojazd albo chwyt zatrzymuje poprzedni */
  function stopGlide(tr) { var a = tr._svA; if (a) { cancelAnimationFrame(a.raf); tr._svA = null; } }
  function release(tr) { if (!tr._svDrag && !tr._svA) tr.classList.remove('is-sv-drag'); }
  function glide(tr, to, opt) {
    opt = opt || {};
    var cont = !!tr._svA;
    stopGlide(tr);
    var from = tr.scrollLeft, d = to - from, v = opt.v || 0;
    if (reduce.matches || Math.abs(d) < 1) { tr.scrollLeft = to; release(tr); return; }
    var fast = Math.abs(v) >= VFLICK && v * d > 0;
    /* rzut: czas z prędkości puszczenia (początek dojazdu ok. tak szybki jak ręka); od zera: łagodny start i koniec */
    var dur = fast ? clamp(2.4 * Math.abs(d) / Math.abs(v), 200, 440) : clamp(Math.abs(d) * 0.55, 260, 460);
    var ez = fast || cont ? easeOut : easeInOut;
    var a = { raf: 0, to: to, i: opt.i };
    tr._svA = a;
    tr.classList.add('is-sv-drag');
    var t0 = performance.now();
    function step(now) {
      if (tr._svA !== a) return;
      var p = clamp((now - t0) / dur, 0, 1);
      tr.scrollLeft = from + d * ez(p);
      if (p < 1) { a.raf = requestAnimationFrame(step); return; }
      tr._svA = null; release(tr);
    }
    a.raf = requestAnimationFrame(step);
  }
  /* gumka na końcu toru (tylko mysz): przesunięcie slajdów zmienną --svg-rb, powrót przejściem CSS */
  function band(x, w) { return (1 - 1 / (Math.abs(x) * 0.55 / w + 1)) * w; }
  function rubber(tr, px) {
    if (!px && !tr._svRb) return;
    tr._svRb = px;
    tr.style.setProperty('--svg-rb', px ? px.toFixed(1) + 'px' : '0px');
  }

  /* ---------- galeria na karcie ---------- */
  var seen = new WeakSet();
  function init(g) {
    if (seen.has(g)) return; seen.add(g);
    var comp = viewerComp(g), tr = trackOf(g); if (!comp || !tr) return;
    /* wariant ustawia skrypt w Liquid (product-media-gallery.liquid, przed pierwszym malowaniem); tu zapas, gdy go nie ma.
       Komputer poza testem: bez data-sv-ab, kropki na wypadek zwężenia okna */
    var AB = null;
    if (!desk.matches) { AB = g.getAttribute('data-sv-ab'); if (AB !== 'dots' && AB !== 'thumbs') AB = abVariant(); }
    var IND = AB === 'thumbs' ? 'thumbs' : 'dots-flow';
    if (AB) g.setAttribute('data-sv-ab', AB);
    g.setAttribute('data-sv-ind', IND);
    var thumbs = g.querySelector('[id^="GalleryThumbnails"] .thumbnail-list');
    /* licznik: własne kopie spanów (motyw trzyma oryginały w currentPageElement / pageTotalElement i pisze do nich przy każdym scrollu) */
    var cnt = comp.querySelector('.slider-counter');
    function own(sel) {
      var el = cnt && cnt.querySelector(sel); if (!el) return null;
      var c = el.cloneNode(false); c.appendChild(document.createTextNode(el.textContent.trim()));
      el.replaceWith(c); return c.firstChild;
    }
    var curT = own('.slider-counter--current'), totT = own('.slider-counter--total');
    var S = measure(g);
    if (totT) totT.nodeValue = S.n;
    /* kropki: rząd pod zdjęciem; dotknięcie albo przesunięcie palca po rzędzie = skok do najbliższej kropki (cały rząd 44 px wysokości,
       jak UIPageControl w iOS); kropki są dla czytników ukryte - czytnik przechodzi po zdjęciach i ma licznik */
    var dots = null, pill = null;
    if (IND === 'dots-flow' && S.n > 1) {
      dots = document.createElement('div');
      dots.className = 'svg-dots'; dots.setAttribute('aria-hidden', 'true');
      var anchor = g.querySelector('.svg-bars') || comp;
      anchor.parentNode.insertBefore(dots, anchor.nextSibling);
      var span = function () { var a = dots.children[0], b = dots.children[1]; if (pill && b && b.offsetParent) dots.style.setProperty('--svg-span', ((b.offsetLeft - a.offsetLeft) * (S.n - 1)) + 'px'); };
      var rebuild = function () {
        dots.innerHTML = new Array(S.n + 1).join('<span class="svg-dot"></span>') + '<i class="svg-dots__pill"></i>';
        pill = dots.querySelector('.svg-dots__pill');
        dots.style.setProperty('--svg-n', S.n);
        span();
      };
      rebuild();
      /* najbliższa kropka do palca (rząd jest szerszy niż kropki, które stoją na środku); środki kropek czytane raz na gest.
         Skok dopiero po dotknięciu (puszczenie bez ruchu w pionie) albo po ruchu w poziomie od 8 px: kciuk, który przewija stronę
         i zaczyna na rzędzie kropek, nie zmienia zdjęcia (przeglądarka zabiera gest = pointercancel) - recenzja 18.10, W1 */
      var scrub = null, cs = [];
      var dotAt = function (x) { var b = 0; for (var k = 1; k < cs.length; k++) if (Math.abs(cs[k] - x) < Math.abs(cs[b] - x)) b = k; return b; };
      var centers = function () { cs = Array.prototype.map.call(dots.querySelectorAll('.svg-dot'), function (d) { var r = d.getBoundingClientRect(); return r.left + r.width / 2; }); };
      dots.addEventListener('pointerdown', function (e) { scrub = { id: e.pointerId, x0: e.clientX, y0: e.clientY, on: false, i: -1 }; });
      dots.addEventListener('pointermove', function (e) {
        if (!scrub || e.pointerId !== scrub.id) return;
        if (!scrub.on) {
          var dx = Math.abs(e.clientX - scrub.x0);
          if (dx < 8 || Math.abs(e.clientY - scrub.y0) > dx) return;
          scrub.on = true; centers(); try { dots.setPointerCapture(e.pointerId); } catch (err) {}
        }
        var i = dotAt(e.clientX); if (i !== scrub.i) { scrub.i = i; jump(g, i, 'dot'); }
      });
      dots.addEventListener('pointerup', function (e) {
        if (scrub && e.pointerId === scrub.id && !scrub.on && Math.abs(e.clientY - scrub.y0) < 10) { centers(); jump(g, dotAt(e.clientX), 'dot'); }
        scrub = null;
      });
      dots.addEventListener('pointercancel', function () { scrub = null; });
      g._svDots = rebuild; g._svSpan = span;
    }
    g.classList.add('is-sv-on');
    /* pigułka płynąca za palcem: animacja sterowana przewijaniem (Chrome 115+, Safari 26+, compositor); bez niej (i przy ograniczonym
       ruchu, gdzie CSS wyłącza animacje) zmienna --svg-p z JS w rAF */
    var sda = !!(dots && !reduce.matches && window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
    g.classList.toggle('is-sv-sda', sda);
    var pRaf = 0;
    function flow() { pRaf = 0; if (pill && S.max) dots.style.setProperty('--svg-p', (tr.scrollLeft / S.max).toFixed(4)); }
    g._svIndex = -1;
    /* następne zdjęcia pobierane z wyprzedzeniem dopiero po pierwszym kontakcie z galerią (bez dodatkowych bajtów przy wejściu) */
    function warm(i) {
      if (!g._svWarm) return;
      var list = slidesOf(g);
      for (var k = i + 1; k <= i + 2; k++) { var im = list[k] && list[k].querySelector('img[loading="lazy"]'); if (im) im.loading = 'eager'; }
    }
    function touch() { if (g._svWarm) return; g._svWarm = true; warm(g._svIndex > 0 ? g._svIndex : 0); }
    g.addEventListener('pointerenter', touch, { passive: true });
    g.addEventListener('touchstart', touch, { passive: true });
    g.addEventListener('focusin', touch);
    function setIndex(i) {
      g._svIndex = i;
      g.setAttribute('data-sv-i', i + 1);
      if (g.dataset.svTarget && +g.dataset.svTarget === i + 1) setTimeout(function () { delete g.dataset.svTarget; }, 0);
      warm(i);
      if (dots) for (var k = 0; k < S.n && k < dots.children.length; k++) dots.children[k].classList.toggle('is-on', k === i);
      if (thumbs && (desk.matches || IND === 'thumbs') && S.ids[i]) {
        var id = S.ids[i], th = thumbs.querySelector('[data-target="' + id + '"]');
        if (th) {
          Array.prototype.forEach.call(thumbs.querySelectorAll('button[aria-current]'), function (b) { if (b.parentNode !== th) b.removeAttribute('aria-current'); });
          var btn = th.querySelector('button'); if (btn) btn.setAttribute('aria-current', 'true');
          var gp = S.thPos.get(id);
          if (!desk.matches) { if (gp && (gp[2] < S.thSL || gp[2] + gp[3] > S.thSL + S.thCW)) thumbs.scrollTo({ left: Math.max(0, gp[2] - (S.thCW - gp[3]) / 2), behavior: reduce.matches ? 'auto' : 'smooth' }); }
          else if (gp && (gp[0] < S.thST || gp[0] + gp[1] > S.thST + S.thCH)) thumbs.scrollTo({ top: Math.max(0, gp[0] - (S.thCH - gp[1]) / 2), behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }
    }
    /* numer zdjęcia z pozycji toru (najbliższe zdjęcie, nie Math.floor jak w motywie); zapis tylko przy zmianie numeru */
    function onScroll() {
      if (pill && !sda && !pRaf) pRaf = requestAnimationFrame(flow);
      var i = idxAt(S, tr.scrollLeft);
      if (i === g._svIndex) return;
      if (curT) curT.nodeValue = i + 1;
      setIndex(i);
    }
    tr.addEventListener('scroll', onScroll, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(function () { measure(g); onScroll(); }).observe(tr);
    if (thumbs) {
      var endCheck = function () { S.thST = thumbs.scrollTop; S.thSL = thumbs.scrollLeft; thumbs.classList.toggle('is-sv-end', S.thST + thumbs.clientHeight >= thumbs.scrollHeight - 2); };
      thumbs.addEventListener('scroll', endCheck, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(function () { endCheck(); measure(g); }).observe(thumbs);
      thumbs.addEventListener('click', function (e) {
        /* telefon z miniaturami: skok naszym dojazdem; media-gallery.js przewija tor do offsetLeft, co przy marginesie
           toru na telefonie przestrzeliwuje o 13,5 px i dociąga przyciąganiem */
        if (!desk.matches && IND === 'thumbs') {
          var tl = e.target.closest('[data-target]'), ti = tl ? S.ids.indexOf(tl.dataset.target) : -1;
          if (ti >= 0 && isImage(slidesOf(g)[ti])) { e.stopPropagation(); e.preventDefault(); jump(g, ti, 'thumb'); return; }
        }
        stopGlide(tr); release(tr);
        g.dataset.svVia = 'thumb';
        /* skok miniaturą przewija tor przez zdjęcia pośrednie: pomiar (sv-events.js) liczy tylko cel */
        var li = e.target.closest('[data-target]'), n = li ? S.ids.indexOf(li.dataset.target) + 1 : 0;
        if (n > 0) g.dataset.svTarget = n;
      }, true);
    }
    /* strzałki na zdjęciu: własna obsługa przed SliderComponent (cel liczony od celu w drodze, nie od pozycji w trakcie animacji) */
    comp.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.slider-button');
      if (!b || b.closest('slider-component') !== comp) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (b.hasAttribute('disabled')) return;
      go(g, b.name === 'next' ? 1 : -1, 'arrow');
    }, true);
    tr.addEventListener('touchstart', function () { stopGlide(tr); release(tr); g.dataset.svVia = 'swipe'; delete g.dataset.svTarget; }, { passive: true });
    tr.addEventListener('wheel', function () { if (tr._svA) { stopGlide(tr); release(tr); } g.dataset.svVia = 'wheel'; delete g.dataset.svTarget; }, { passive: true });
    tr.addEventListener('dragstart', function (e) { e.preventDefault(); });
    /* zmiana koloru przestawia slajdy (media-gallery.js / product-info.js): geometria, kropki i numer od nowa */
    new MutationObserver(function () { stopGlide(tr); release(tr); measure(g); if (totT) totT.nodeValue = S.n; g._svIndex = -1; onScroll(); }).observe(tr, { childList: true });
    onScroll();
    if (AB && !abSent) { abSent = true; emit('sv:gallery-ab', { variant: AB, gallery: g }); }
  }

  function go(g, delta, via) {
    var S = g._sv || measure(g), tr = S.tr, a = tr._svA;
    var base = a && a.i != null ? a.i : idxAt(S, tr.scrollLeft);
    jump(g, base + delta, via);
  }
  function jump(g, i, via) {
    var S = g._sv || measure(g), tr = S.tr, a = tr._svA;
    i = clamp(i, 0, S.n - 1);
    g.dataset.svVia = via;
    g.dataset.svTarget = i + 1;
    if (a && a.i === i) return;
    glide(tr, posOf(S, i), { i: i });
  }

  /* przeciąganie myszą (dotyk zostaje natywny) */
  var drag = null, dragRaf = 0, eatClick = 0;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0 || !e.target.closest) return;
    var tr = e.target.closest(SEL + ' .product__media-list'), g = tr && tr.closest(SEL);
    if (!tr) {
      var b = e.target.closest(SEL + ' slider-component[id^="GalleryViewer"] > .slider-buttons .slider-button');
      if (b) { g = b.closest(SEL); tr = trackOf(g); }
    }
    if (tr && g) { init(g); startDrag(e, tr, g); }
  });
  function startDrag(e, tr, g) {
    var onBtn = !!e.target.closest('.slider-button');
    if (!onBtn && e.target.closest('button, a, video, iframe, model-viewer')) return;
    var S = g._sv || measure(g);
    if (S.n < 2) return;
    var moving = !!tr._svA, aim = moving && tr._svA.i != null ? { i: tr._svA.i, dir: tr._svA.to > tr.scrollLeft ? 1 : -1 } : null;
    /* chwyt zatrzymuje jadący tor (jak palec na iPhonie); na strzałce dopiero ruch, bo klik strzałki ma przejąć dojazd */
    if (!onBtn && moving) { stopGlide(tr); tr._svDrag = true; }
    drag = { tr: tr, g: g, S: S, id: e.pointerId, x0: e.clientX, x: e.clientX, s0: tr.scrollLeft, moved: false, h: [[e.timeStamp, e.clientX]], moving: moving && !onBtn, onBtn: onBtn, aim: aim };
  }
  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag;
    if (!d.moved) {
      if (Math.abs(e.clientX - d.x0) < 6) return;
      d.moved = true;
      if (!d.aim && d.tr._svA && d.tr._svA.i != null) d.aim = { i: d.tr._svA.i, dir: d.tr._svA.to > d.tr.scrollLeft ? 1 : -1 };
      stopGlide(d.tr);
      d.s0 = d.tr.scrollLeft; d.x0 = e.clientX; /* bez skoku o próg 6 px */
      d.tr._svDrag = true;
      d.tr.classList.add('is-sv-drag');
      try { d.tr.setPointerCapture(d.id); } catch (err) {}
      d.g.dataset.svVia = 'drag'; delete d.g.dataset.svTarget;
    }
    d.x = e.clientX;
    var h = d.h; h.push([e.timeStamp, e.clientX]);
    while (h.length > 2 && e.timeStamp - h[0][0] > 100) h.shift();
    if (!dragRaf) dragRaf = requestAnimationFrame(paint);
  });
  function paint() {
    dragRaf = 0;
    var d = drag; if (!d || !d.moved) return;
    var p = d.s0 - (d.x - d.x0), over = 0;
    if (p < 0) { over = -p; p = 0; } else if (p > d.S.max) { over = d.S.max - p; p = d.S.max; }
    d.tr.scrollLeft = p;
    rubber(d.tr, over ? band(over, d.S.w || d.tr.clientWidth) * (over > 0 ? 1 : -1) : 0);
  }
  function endDrag(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var d = drag, tr = d.tr, S = d.S; drag = null;
    if (dragRaf) { cancelAnimationFrame(dragRaf); dragRaf = 0; }
    tr._svDrag = false;
    if (!d.moved) {
      /* klik bez ruchu: tor zatrzymany chwytem wraca do najbliższego zdjęcia */
      if (d.moving) { eatClick = e.timeStamp; var j = idxAt(S, tr.scrollLeft); glide(tr, posOf(S, j), { i: j }); }
      else release(tr);
      return;
    }
    eatClick = e.timeStamp;
    var h = d.h, v = 0, last = h[h.length - 1];
    if (h.length > 1 && e.timeStamp - last[0] < 60) {
      var k = 0; while (k < h.length - 2 && last[0] - h[k][0] > 80) k++;
      var dt = last[0] - h[k][0]; if (dt > 0) v = (last[1] - h[k][1]) / dt;
    }
    var vs = -v; /* prędkość toru: dodatnia = w stronę następnych zdjęć */
    var p = clamp(d.s0 - (d.x - d.x0), 0, S.max), base = p / S.step, i;
    if (Math.abs(vs) >= VFLICK) {
      i = vs > 0 ? Math.ceil(base - 0.02) : Math.floor(base + 0.02);
      /* kolejny rzut w tę samą stronę w trakcie dojazdu sumuje się (jak natywny dotyk): cel przerwanego dojazdu + 1 */
      if (d.aim && d.aim.dir * vs > 0) i = vs > 0 ? Math.max(i, d.aim.i + 1) : Math.min(i, d.aim.i - 1);
    } else i = Math.round(base);
    i = clamp(i, 0, S.n - 1);
    tr.scrollLeft = p;
    if (tr._svRb) { tr.classList.add('is-sv-rb'); rubber(tr, 0); setTimeout(function () { tr.classList.remove('is-sv-rb'); }, 460); }
    d.g.dataset.svVia = 'drag'; delete d.g.dataset.svTarget;
    glide(tr, posOf(S, i), { v: vs, i: i });
  }
  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);
  /* klik kończący przeciąganie (albo chwyt jadącego toru) nie trafia do zdjęcia ani odnośnika pod kursorem */
  document.addEventListener('click', function (e) {
    if (eatClick && e.timeStamp - eatClick < 400) { eatClick = 0; e.preventDefault(); e.stopPropagation(); }
  }, true);

  /* klawisze: na karcie strzałki przewijają galerię, gdy kursor albo fokus jest na niej; kolejne naciśnięcia sumują się */
  var hovered = null;
  document.addEventListener('pointerover', function (e) {
    var g = e.target.closest && e.target.closest(SEL);
    hovered = g || null;
    if (g) init(g);
  }, { passive: true });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if (e.altKey || e.ctrlKey || e.metaKey || e.shiftKey) return;
    var a = document.activeElement;
    if (a && (/^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName) || a.isContentEditable)) return;
    if (e.defaultPrevented) return;
    var inG = a && a.closest && a.closest(SEL);
    var g = inG || ((!a || a === document.body || a === document.documentElement) ? hovered : null); if (!g) return;
    init(g); e.preventDefault();
    go(g, e.key === 'ArrowRight' ? 1 : -1, 'key');
  });

  function boot() { Array.prototype.forEach.call(document.querySelectorAll(SEL), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.svGaleria = { init: init };
})();
